module.exports = __webpack_public_path__ + "img/sun_icon.a052b3f3.svg";